import { twMerge } from "tailwind-merge";

type SpinnerProps = {
  size?: "sm" | "md" | "xl";
  className?: string;
  "aria-label"?: string;
};

const SIZES = { sm: "w-4 h-4 border-2", md: "w-6 h-6 border-2", xl: "w-10 h-10 border-4" };

function Spinner({ size = "md", className, ...rest }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={rest["aria-label"] || "Loading"}
      className={twMerge(
        "inline-block rounded-full border-line-strong border-t-brand-to animate-spin",
        SIZES[size],
        className
      )}
    />
  );
}

export default Spinner;
